import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Cloud"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.9996 5.24997C12.3799 5.2499 12.7593 5.28758 13.1321 5.36247C15.5428 5.82416 17.4292 7.70756 17.8946 10.1175L18.0896 11.13L19.1021 11.31C21.2229 11.6747 22.707 13.6085 22.5108 15.7515C22.3145 17.8944 20.5039 19.5265 18.3521 19.5H5.62464C3.47288 19.5265 1.66225 17.8944 1.46601 15.7515C1.26977 13.6085 2.75385 11.6747 4.87464 11.31L5.87964 11.13L6.07464 10.1175C6.61998 7.27997 9.11026 5.23416 11.9996 5.24997ZM11.9995 3.75C8.39876 3.74701 5.304 6.30342 4.62705 9.84C1.76427 10.3583 -0.230898 12.9741 0.026178 15.8721C0.283254 18.77 2.70773 20.9937 5.61705 21H18.3671C21.2764 20.9937 23.7008 18.77 23.9579 15.8721C24.215 12.9741 22.2198 10.3583 19.357 9.84C18.779 6.8227 16.4193 4.46301 13.4021 3.885C12.9397 3.79725 12.4702 3.75206 11.9995 3.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Cloud.vue"]]);
